class PricingItem {
  id = Date.now() + Math.random();
  totalprice = 0;
  netprice = 0;
  companyid = null;
  companyname = "";
  discountedprice = "";
  insurancerequestid = 0;
  ratio = 0;
  feature = null;
}
export default PricingItem;
